import axios from 'axios'
import qs from 'qs'
import {Message, Spin} from 'iview'
import router from '@/router'
import Cookies from 'js-cookie';

const dev = '/api';
const pro = '';

// axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;      // 允许跨域axios携带cookie
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
// axios.defaults.crossDomain = true;
// axios.defaults.headers.common['Authorization'] = ''; // 设置请求头为 Authorization

// 配置域名(生成环境为相对路径)
export const BaseUrl = Object.is(process.env.NODE_ENV, 'production') ? '' : dev;

//export const environmentDomain = Object.is(process.env.NODE_ENV, 'production') ? (location.href.indexOf('https://adminv3.lkkids.com') != -1 ? 'https://adminv3.lkkids.com' : 'https://v3testadmin.lkkids.com') : 'https://v3testadmin.lkkids.com';
export const environmentDomain = 'http://admin.jiaxinlink.com'
// axios.defaults.baseURL = dev;
let config = {headers: {'Content-Type': 'application/json'}};  //添加请求头


/*************************  设备模块  ***************************/



// 获取门设备控制配置列表
export const getDoorCtrlList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/door_ctrl/query_list`, {params}).then(res => res.data)
}

// 添加门设备控制配置
export const addDoorCtrl = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_ctrl/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑门设备控制配置
export const modifyDoorCtrl = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_ctrl/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取门设备控制配置详情
export const getDoorCtrl = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/door_ctrl/get_info`, {params}).then(res => res.data)
}

// 删除门设备控制配置
export const deleteDoorCtrl = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_ctrl/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取门设备上报配置列表
export const getDoorReportList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/door_report/query_list`, {params}).then(res => res.data)
}

// 添加门设备上报配置
export const addDoorReport = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_report/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑门设备上报配置
export const modifyDoorReport = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_report/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取门设备上报配置详情
export const getDoorReport = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/door_report/get_info`, {params}).then(res => res.data)
}

// 删除门设备上报配置
export const deleteDoorReport = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/door_report/delete`, qs.stringify(params)).then(res => res.data)
}

// 查询设备型号接口
export const getDeviceModel = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_device_model`, {params}).then(res => res.data);
};

// 添加设备型号接口
export const addDeviceModel = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_device_model`, qs.stringify(params)).then(res => res.data);
};

// 编辑设备型号接口
export const editDeviceModel = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/modify_device_model`, qs.stringify(params)).then(res => res.data);
};

// 查询设备接口
export const getDevice = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_device`, {params}).then(res => res.data);
};

// 查询用户设备接口
export const getUserDevice = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_user_device`, {params}).then(res => res.data);
};

// 添加设备接口
export const addDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_device`, qs.stringify(params)).then(res => res.data);
};

// 批量添加设备接口
export const addDeviceBat = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_devicebat`, qs.stringify(params)).then(res => res.data);
};

// 添加摄像头设备接口
export const addCamera = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_camera`, qs.stringify(params)).then(res => res.data);
};

// 修改设备接口
export const editDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/modify_device`, qs.stringify(params)).then(res => res.data);
};

// 删除设备接口
export const deleteDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/del_device`, qs.stringify(params)).then(res => res.data);
};

// 同步设备物模型接口
export const updateDeviceModel = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/update_devicemodel`, qs.stringify(params)).then(res => res.data);
};

// 查询车牌接口
export const getCarCode = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-device/pc/code/query_list`, {params}).then(res => res.data);
};

// 添加车牌接口
export const addCarCode = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-device/pc/code/add`, qs.stringify(params)).then(res => res.data);
};

// 批量添加车牌接口
export const batchAddCarCode = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-device/pc/code/add_list`, qs.stringify(params)).then(res => res.data);
};

// 导出车牌接口
export const exportCarCode = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-device/pc/code/export`, {
    params,
    headers: {responseType: 'blob'}
  }).then(res => res.data);
};

// 查询盒子接口
export const getCarBox = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-device/pc/box/query_list`, {params}).then(res => res.data);
};

// 添加盒子接口
export const addCarBox = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-device/pc/box/add`, qs.stringify(params)).then(res => res.data);
};

// 编辑盒子接口
export const editCarBox = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}box/update`, qs.stringify(params)).then(res => res.data);
};

// 获取设备类型物模型属性定义列表
export const getDeviceTypePhyProList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typepro_rela/query_list`, {params}).then(res => res.data)
}

// 添加设备类型物模型属性
export const addDeviceTypePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typepro_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备类型物模型属性
export const modifyDeviceTypePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typepro_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型属性详情
export const getDeviceTypePhyPro = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typepro_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备类型物模型属性
export const deleteDeviceTypePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typepro_rela/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型功能定义列表
export const getDeviceTypePhyFuncList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typefunc_rela/query_list`, {params}).then(res => res.data)
}

// 添加设备类型物模型功能
export const addDeviceTypePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备类型物模型功能
export const modifyDeviceTypePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型功能
export const getDeviceTypePhyFunc = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typefunc_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备类型物模型功能
export const deleteDeviceTypePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型功能输入参数定义列表
export const getDeviceTypePhyFuncInList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typefunc_rela/inquery_list`, {params}).then(res => res.data)
}

// 添加设备类型物模型功能输入参数
export const addDeviceTypePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/insave`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备类型物模型功能输入参数
export const modifyDeviceTypePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/inmodify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型功能输入参数
export const getDeviceTypePhyFuncIn = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typefunc_rela/inget_info`, {params}).then(res => res.data)
}

// 获取设备类型物模型功能定义全量列表（包含参数）
export const getDeviceTypePhyFuncAllList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typefunc_rela/allquerys_list`, {params}).then(res => res.data)
}

// 删除设备类型物模型功能输入参数
export const deleteDeviceTypePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typefunc_rela/indelete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型事件定义列表
export const getDeviceTypePhyEventList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typeevent_rela/query_list`, {params}).then(res => res.data)
}

// 添加设备类型物模型事件
export const addDeviceTypePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typeevent_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备类型物模型事件
export const modifyDeviceTypePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typeevent_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型事件
export const getDeviceTypePhyEvent = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/typeevent_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备类型物模型事件
export const deleteDeviceTypePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/typeevent_rela/delete`, qs.stringify(params)).then(res => res.data)
}





// 获取设备物模型属性定义列表
export const getDevicePhyProList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devpro_rela/query_list`, {params}).then(res => res.data)
}

// 添加设备物模型属性
export const addDevicePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devpro_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备物模型属性
export const modifyDevicePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devpro_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型属性详情
export const getDevicePhyPro = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devpro_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备物模型属性
export const deleteDevicePhyPro = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devpro_rela/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型功能定义列表
export const getDevicePhyFuncList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devfunc_rela/query_list`, {params}).then(res => res.data)
}

// 获取设备物模型功能定义全量列表（包含参数）
export const getDevicePhyFuncAllList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devfunc_rela/allquery_list`, {params}).then(res => res.data)
}

// 添加设备物模型功能
export const addDevicePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备物模型功能
export const modifyDevicePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型功能
export const getDevicePhyFunc = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devfunc_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备物模型功能
export const deleteDevicePhyFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型功能输入参数定义列表
export const getDevicePhyFuncInList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devfunc_rela/inquery_list`, {params}).then(res => res.data)
}

// 添加设备物模型功能输入参数
export const addDevicePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/insave`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备物模型功能输入参数
export const modifyDevicePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/inmodify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型功能输入参数
export const getDevicePhyFuncIn = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devfunc_rela/inget_info`, {params}).then(res => res.data)
}

// 删除设备物模型功能输入参数
export const deleteDevicePhyFuncIn = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devfunc_rela/indelete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型事件定义列表
export const getDevicePhyEventList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devevent_rela/query_list`, {params}).then(res => res.data)
}

// 添加设备物模型事件
export const addDevicePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devevent_rela/save`, qs.stringify(params)).then(res => res.data)
}

// 编辑设备物模型事件
export const modifyDevicePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devevent_rela/modify`, qs.stringify(params)).then(res => res.data)
}

// 获取设备物模型事件
export const getDevicePhyEvent = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/devevent_rela/get_info`, {params}).then(res => res.data)
}

// 删除设备物模型事件
export const deleteDevicePhyEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/devevent_rela/delete`, qs.stringify(params)).then(res => res.data)
}

// 获取设备类型物模型列表
export const getDevicePhyList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device_rela/query_list`, {params}).then(res => res.data)
}

/*************************  用户管理  ***************************/
// 获取微信用户接口
export const getWeChatUser = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/wx_user/query_list`, {params}).then(res => res.data);
};

// 用户解绑接口
export const userUnbindDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/wx_user/unbind_device`, qs.stringify(params)).then(res => res.data)
};


/*************************  商家管理  ***************************/
// 获取商家接口
export const getBusiness = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-merchant/pc/merchant/query_list`, {params}).then(res => res.data);
};

// 添加商家接口
export const addBusiness = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-merchant/pc/merchant/add`, qs.stringify(params)).then(res => res.data);
};

// 获取商家微信接口
export const getBusinessWeChat = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-merchant/pc/wechat/query_list`, {params}).then(res => res.data);
};

// 获取商家充值接口
export const getBusinessRecharge = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/merchant_recharge/query_list`, {params}).then(res => res.data);
};

// 获取商家结算接口
export const getBusinessAccount = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/merchant_settle/query_list`, {params}).then(res => res.data);
};

// 获取商家账单接口
export const getBusinessBill = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/merchant_month/query_list`, {params}).then(res => res.data);
};

// 获取商家银行卡信息
export const getMerchantBankMsg = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-merchant/mobile/bank_cards_message/get_merchant_bankcards`, {params}).then(res => res.data);
};

// 商家驳回提现接口
export const rejectedWithdrawal = params => {
    params.token = getToken();
    return axios.post(`${BaseUrl}/api-order/pc/merchant_settle/update`, qs.stringify(params)).then(res => res.data); };

// 合伙人驳回提现接口
export const partnerRejectedWithdrawal = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-order/pc/partner_settle/update_state`, qs.stringify(params)).then(res => res.data); };

/*************************  订单管理  ***************************/
// 获取当日消费订单接口
export const getDayOrder = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/consume/query_list`, {params}).then(res => res.data);
};

// 获取当日退款订单
export const getDayRefundOrder = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/refund/query_list`, {params}).then(res => res.data);
};

// 获取当日充值订单
export const getRechargeOrder = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/merchant_recharge/query_list`, {params}).then(res => res.data);
};

// 退单接口
export const refundOrder = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-order/cpm/refund/refund`, qs.stringify(params)).then(res => res.data);
};

// 获取历史消费订单
export const getHisOrder = (params,cancelToken) => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/consume/query_history`, {params,cancelToken}).then(res => res.data);
};

/*************************  合伙人管理  ***************************/
// 获取合伙人类型接口
export const getPartnerType = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-city/pc/type/query_list`, {params}).then(res => res.data);
};

// 获取合伙人结算接口
export const getPartnerAccount = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/partner_settle/query_list`, {params}).then(res => res.data);
};

// 添加合伙类型
export const addPartnerType = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/type/add`, qs.stringify(params)).then(res => res.data);
};

// 编辑合伙类型
export const editPartnerType = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/type/update`, qs.stringify(params)).then(res => res.data);
};

// 获取意向合伙列表
export const getIntentionPartner = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-city/pc/purpose/query_list`, {params}).then(res => res.data);
};

// 添加意向合伙
export const addIntentionPartner = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/purpose/add`, qs.stringify(params)).then(res => res.data);
};

// 编辑意向合伙
export const editIntentionPartner = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/purpose/update`, qs.stringify(params)).then(res => res.data);
};

// 获取合作合伙列表
export const getTeamPartner = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-city/pc/city/query_list`, {params}).then(res => res.data);
};

// 添加合作合伙
export const addTeamPartner = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/city/add`, qs.stringify(params)).then(res => res.data);
};

// 编辑合作合伙
export const editTeamPartner = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-city/pc/city/update`, qs.stringify(params)).then(res => res.data);
};

// 获取合伙人银行卡信息
export const getPartnerBankMsg = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-city/pc/city/get_phone`, {params}).then(res => res.data);
};


/*************************  登录模块  ***************************/
// 获取管理平台pc端登陆验证码
export const getLoginVerificationCode = params => {
  return axios.get(`${BaseUrl}/api-mainserver/pc/admin/get_verification`, {params}).then(res => res.data);
};

// 嘉信平台用户登录
export const login = params => {
  return axios.post(`${BaseUrl}/api-mainserver/pc/admin/login`, qs.stringify(params)).then(res => res.data);
};

// 嘉信平台获取短信验证码
export const getPhonever = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/admin/get_phonever`, qs.stringify(params)).then(res => res.data);
};

// 嘉信平台重置密码
export const restPassword = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/admin/rest_password`, qs.stringify(params)).then(res => res.data);
};

/*************************  terminal  ***************************/
// 添加角色
export const addRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/linkids_role/add`, qs.stringify(params)).then(res => res.data);
};

// 编辑角色
export const editRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/linkids_role/update`, qs.stringify(params)).then(res => res.data);
};

// 获取角色列表
export const getRoleList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/linkids_role/query_list`, {params}).then(res => res.data);
};

// 获取权限文本
export const getRoleTxt = (url,params) => {
  return axios.get(url, {params}).then(res => res.data);
};

// 运营平台人员添加
export const addManageRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/admin/add`, qs.stringify(params)).then(res => res.data);
};

// 运营平台人员列表
export const manageRoleList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/admin/query_list`, {params}).then(res => res.data);
};

// 运营平台人员编辑
export const editManageRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/admin_role/update`, qs.stringify(params)).then(res => res.data);
};

// 运营平台获取运营数据
export const findToDay = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/admin/findToDay`, {params}).then(res => res.data);
};

/*************************  工单模块  ***************************/
// 获取工单列表
export const getWorkOrder = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/work/query_list`, {params}).then(res => res.data);
};


/*************************  财务模块  ***************************/
// 获取合伙人月报
export const getPartnerMReport = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/partner_month/query_list`, {params}).then(res => res.data);
};

// 手动销账
export const manualMoney = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-order/pc/merchant_settle/update`, qs.stringify(params)).then(res => res.data);
};

/*************************  厂家模块  ***************************/
// 查询厂商级别(全部)
export const getFactoryLevel = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/get_factory_level`, {params}).then(res => res.data);
};

// 查询厂商级别(过滤+分页)
export const getFactoryLevelY = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/list_factory_level`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加厂商级别
export const addFactoryLevel = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/add_factory_level`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑厂商级别
export const editFactoryLevel = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/modify_factory_level`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 查询厂商角色(全部)
export const getFactoryRole = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/get_factory_role`, {params}).then(res => res.data);
};

// 查询厂商角色(过滤+分页)
export const getFactoryRoleY = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/list_factory_role`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加厂商角色
export const addFactoryRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/add_factory_role`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑厂商角色
export const editFactoryRole = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/modify_factory_role`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 查询厂商员工(过滤+分页)
export const getFactoryMem = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/list_factory_mem`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加厂商员工
export const addFactoryMem = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/add_factory_mem`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑厂商员工
export const editFactoryMem = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/modify_factory_mem`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 查询厂商(全部)
export const getFactory = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/get_factory`, {params}).then(res => res.data);
};

// 查询厂商(过滤+分页)
export const getFactoryY = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/list_factory`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加厂商
export const addFactory = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/add_factory`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑厂商
export const editFactory = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/modify_factory`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 获取厂商APP版本列表
export const getFactoryAppList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/app_list`, {params}).then(res => res.data)
}

// 添加厂商APP版本
export const addFactoryApp = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/app_save`, qs.stringify(params)).then(res => res.data)
}

// 编辑厂商APP版本
export const modifyFactoryApp = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/app_modify`, qs.stringify(params)).then(res => res.data)
}

// 获取厂商APP版本详情
export const getFactoryAppinfo = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/app_info`, {params}).then(res => res.data)
}

// 删除厂商APP版本
export const deleteFactoryApp = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/app_delete`, qs.stringify(params)).then(res => res.data)
}



// 获取厂商们类型列表
export const getFactoryDoorList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/door_list`, {params}).then(res => res.data)
}

// 添加厂商们类型
export const addFactoryDoor = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/door_save`, qs.stringify(params)).then(res => res.data)
}

// 编辑厂商门类型
export const modifyFactoryDoor = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/door_modify`, qs.stringify(params)).then(res => res.data)
}

// 获取厂商门类型详情
export const getFactoryDoorinfo = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/door_info`, {params}).then(res => res.data)
}

// 删除厂商门类型
export const deleteFactoryDoor = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/door_delete`, qs.stringify(params)).then(res => res.data)
}


// 获取厂商广告列表
export const draw_adv = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/adv/query_list`, {params}).then(res => res.data)
}

// 添加厂商广告
export const draw_advadd = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/add`, qs.stringify(params)).then(res => res.data)
}

// 更新厂商广告
export const draw_advupdate = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/update`, qs.stringify(params)).then(res => res.data)
}

// 更新厂商广告状态
export const draw_advupdate_status = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/update_status`, qs.stringify(params)).then(res => res.data)
}

// 删除厂商广告
export const draw_advdelete = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/delete`, qs.stringify(params)).then(res => res.data)
}

// 上传图片
export const uploadImg = params => {
  params.append('token',getToken());
  var config = {
    headers: {
      'Content-Type':'multipart/form-data'
    }
  };
  console.log(params);
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/upload_img`, params, config).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 替换图片
export const replaceImg = params => {
  params.append('token',getToken());
  var config = {
    headers: {
      'Content-Type':'multipart/form-data'
    }
  };
  console.log(params);
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/adv/replace_img`, params, config).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

/*************************  供销商管理  ***************************/
// 查询供销商接口
export const getVendorList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/vendor/list_vendor`, {params}).then(res => res.data);
};

// 添加供销商接口
export const addVendor = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/vendor/add_vendor`, qs.stringify(params)).then(res => res.data);
};

// 编辑供销商接口
export const editVendor = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/vendor/update_vendor`, qs.stringify(params)).then(res => res.data);
};

// 删除供销商接口
export const deleteVendor = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/vendor/delete_vendor`, {params}).then(res => res.data);
};

// 查询供销商微信接口
export const getVendorWechatList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/vendor_wechat/query_list`, {params}).then(res => res.data);
};

//查询二级类目

export const commodity_secondtype = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodity_secondtype/list`, {params}).then(res => res.data);
};
//添加二级类目

export const addcommodity_secondtype = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodity_secondtype/add`, qs.stringify(params)).then(res => res.data);
};
//编辑二级类目

export const updatecommodity_secondtype = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodity_secondtype/update`, qs.stringify(params)).then(res => res.data);
};
//删除二级类目
export const pccommodity_secondtype = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodity_secondtype/delete`,  {params}).then(res => res.data);
};
//获取类目列表

export const first_secondcommodity_secondtype = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodity_secondtype/first_second`,  {params}).then(res => res.data);
};
//添加供销商角色
export const addroleresource = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/role_resource/add`, qs.stringify(params)).then(res => res.data);
};
//获取供销商权限列表

export const returnlist = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/role_resource/return_list`, {params}).then(res => res.data);
};

/*************************  区域模块  ***************************/

// 查询区域(过滤+分页)
export const getUserArea = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/user_area/list_area`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加区域
export const addUserArea = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/user_area/add_area`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑区域
export const editUserArea = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/user_area/modify_area`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 删除区域
export const delUserArea = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/user_area/del_area`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 区域批量添加设备
export const addUserAreaDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/user_area/area_add_device`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 区域批量删除设备
export const delUserAreaDevice = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/user_area/area_del_device`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 查询区域设备接口
export const getAreaDevice = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/user_area/list_area_device`, {params}).then(res => res.data);
};

/*************************  设备控制  ***************************/
// 设备控制
export const sendDeviceOnoff = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mqtt/pc/mqtt/sendOnOff`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 设备功能调用
export const sendDeviceFunc = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mqtt/pc/mqtt/sendFunc`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 设备事件测试
export const sendDeviceEvent = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mqtt/pc/mqtt/send_event`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 设备OTA升级
export const sendDeviceOta = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mqtt/pc/mqtt/sendOta`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 设备重启
export const sendDeviceReboot = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mqtt/pc/mqtt/sendReboot`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 上传文件
export const uploadFile = params => {
  params.append('token',getToken());
  var config = {
    headers: {
      'Content-Type':'multipart/form-data'
    }
  };
  console.log(params);
  return axios.post(`${BaseUrl}/api-mainserver/pc/admin/uploadFile`, params, config).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

/*************************  摄像头控制  ***************************/
// 摄像头控制HLS流
export const getCameraVideo = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/camera/get_camera_video`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 摄像头控制EZ流
export const getCameraVideoEz = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/camera/get_camera_videoEz`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 摄像头抓图
export const getCameraCapture = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/xmcamera/get_camera_capture`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

/*************************  规则管理  ***************************/
// 获取手动规则
export const getHandlelinkList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/link/list_handlelink`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 获取事件规则
export const getEventlinkList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/link/list_eventlink`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 获取定时规则
export const getTimelinkList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/link/list_timelink`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 获取用户联动事件列表
export const getLinkeventList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/link/list_linkevent`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 获取用户联动动作列表
export const getLinkactionList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/link/list_linkaction`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 添加联动
export const addLinkRule = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/mobile/link/create_link`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 删除联动
export const delLinkRule = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/mobile/link/del_link`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};


/*************************  设备日志  ***************************/
// 设备日志
export const listDeviceLog = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device_log/list_his_log`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 用户操作日志
export const listUserLog = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/user_log/list_his_log`, {params}).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

/*************************  其他模块  ***************************/
// 获取地区接口
export const getArea = params => {
  return axios.get(`${BaseUrl}/api-mainserver/pc/admin/get_area`, {params}).then(res => res.data);
};

// 查询设备类型(伍豪)
export const getDeviceType = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/get_device_type`, {params}).then(res => res.data);
};

// 查询设备类型(迎松)
export const getDeviceTypeY = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_device_type`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_type`, {params}).then(res => res.data);
};

// 添加设备类型
export const addDeviceType = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_device_type`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_type`, qs.stringify(params)).then(res => res.data);
};

// 编辑设备类型
export const editDeviceType = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/modify_device_type`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_type`, qs.stringify(params)).then(res => res.data);
};

// 查询设备品牌(伍豪)
export const getDeviceBrand = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/get_device_brand`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/get_device_brand`, {params}).then(res => res.data);
};

// 查询设备品牌(迎松)
export const getDeviceBrandY = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_device_brand`, {params}).then(res => res.data);
  //return axios.get(`${BaseUrl}/api-device/pc/device/list_device_brand`, {params}).then(res => res.data);
};

// 添加设备品牌
export const addDeviceBrand = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_device_brand`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/add_device_brand`, {params}).then(res => res.data);
};

// 编辑设备样式
export const editDeviceBrand = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/modify_device_brand`, qs.stringify(params)).then(res => res.data);
  //return axios.post(`${BaseUrl}/api-device/pc/device/update_style`, qs.stringify(params)).then(res => res.data);
};

// 查询设备型号
export const getDeviceModels = params => {
  /*if (sessionStorage.actionPrice && JSON.parse(sessionStorage.actionPrice)) {
    return new Promise((resolve) => {
      resolve(JSON.parse(sessionStorage.actionPrice));
    })
  } else {
    params.token = getToken();
    return axios.get(`${BaseUrl}/api-device/pc/device/get_device_price`, {params}).then(res => res.data);
  }*/
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/get_device_model`, {params}).then(res => res.data);
};

/*************************  设备OTA模块  ***************************/
// 添加设备OTA
export const addDeviceOta = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/add_dev_ota`, qs.stringify(params)).then(res => res.data);
};

// 编辑设备OTA
export const editDeviceOta = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/modify_dev_ota`, qs.stringify(params)).then(res => res.data);
};

// 获取设备OTA列表
export const getDeviceOta = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/device/list_dev_ota`, {params}).then(res => res.data);
};

// 删除设备OTA
export const delDeviceOta = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/device/del_dev_ota`, qs.stringify(params)).then(res => res.data);
};

/*************************  商品管理  ***************************/
//获取一级类目表

export const commodity_firsttype = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodity_firsttype/list`, {params}).then(res => res.data);
};
//添加一级类目

export const addcommodity_firsttype = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodity_firsttype/add`, qs.stringify(params)).then(res => res.data);
};
//编辑一级类目

export const updatecommodity_firsttype = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodity_firsttype/update`, qs.stringify(params)).then(res => res.data);
};
//删除一级类目

export const deletecommodity_firsttype = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodity_firsttype/delete`, {params}).then(res => res.data);
};

// 查询商品列表
export const getGoodsList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/commodities/list_commodities`, {params}).then(res => res.data);
};

// 添加商品接口
export const addGoods = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/commodities/add_commodities`, qs.stringify(params)).then(res => res.data);
};

// 编辑商品接口
export const editGoods = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/commodities/modify_commodities`, qs.stringify(params)).then(res => res.data);
};

// 供销商给合伙人上架商品接口
export const shelvesGoods = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/commodities/up_partner_commodities`, qs.stringify(params)).then(res => res.data);
};

// 供销商给合伙人下架商品接口
export const downShelvesGoods = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-mainserver/pc/factory/commodities/down_partner_commodities`, qs.stringify(params)).then(res => res.data);
};

// 获取当前商品对应上架了的合伙人列表
export const goodsForPartner = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-mainserver/pc/factory/commodities/list_partner_commodities`, {params}).then(res => res.data);
};

// 查询商品接口
export const getGoodsListDealer = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodities/list_commodities`, {params}).then(res => res.data);
};

// 添加商品接口
export const addGoodsDealer = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodities/add_commodities`, qs.stringify(params)).then(res => res.data);
};
//查询商品库存接口

export const commoditystocks = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/stocks/commodity_stocks`, {params}).then(res => res.data);
};
//商品入库接口
export const commoditypurchase = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/stocks/commodity_purchase`, qs.stringify(params)).then(res => res.data);
};
//商品出库接口
export const commodityshipment = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/stocks/commodity_shipment`, qs.stringify(params)).then(res => res.data);
};

//查询商品入库历史记录
export const commoditypurchaselist = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/stocks/commodity_purchase_list`, {params}).then(res => res.data);
};
//查询商品出库历史记录
export const commodityshipmentlist = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/stocks/commodity_shipment_list`, {params}).then(res => res.data);
};
//查询入库详情
export const purchasedetail = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/stocks/purchase_detail`, {params}).then(res => res.data);
};
//查询出库详情
export const shipmentdetail = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/stocks/shipment_detail`, {params}).then(res => res.data);
};

// 编辑商品接口
export const editGoodsDealer = params => {
  params.token = getToken();
  return axios.post(`${BaseUrl}/api-vendor/pc/commodities/update_commodities`, qs.stringify(params)).then(res => res.data);
};

// 删除商品接口
export const deleteGoodsDealer = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-vendor/pc/commodities/delete_commodities`, {params}).then(res => res.data);
};

/*************************  订单管理  ***************************/

// 获取供销商账单
export const getVendorBillList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/ven_month/query_list`, {params}).then(res => res.data);
};

// 获取供销商今日订单
export const getVendorOrderList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/ven_order/ven/query_list`, {params}).then(res => res.data);
};

// 获取供销商历史订单
export const getVendorHisOrderList = params => {
  params.token = getToken();
  return axios.get(`${BaseUrl}/api-order/pc/ven_order/ven/query_history`, {params}).then(res => res.data);
};

export const refundOrders = (params, type = 1) => {
  params.token = getToken();
  // 盒子退单
  // return axios.post(`${BaseUrl}/api-order/cpm/refund/refund`, qs.stringify(params)).then(res => res.data);
  // return axios.post(`${BaseUrl}/api-order/cpm/refund/history/yunst_refund`, qs.stringify(params)).then(res => res.data);
  // if (type == 9) {
  //   // 微信退单
      return axios.post(`${BaseUrl}/api-order/cpm/refund/refund`, qs.stringify(params)).then(res => res.data);
  // } else {
  //   // 通联退单
  // return axios.post(`${BaseUrl}/api-order/cpm/refund/yunst_refund`, qs.stringify(params)).then(res => res.data);
  // }
};

export default (_ => {
  axios.interceptors.response.use(data => {// 响应成功关闭loading
    if (data.status == 200) {
      let res = data.data;
      if (res.code == 0) {
        Spin.hide();
        Message.error(res.message ? res.message : `没有获取到数据,或者数据格式是错的!`);
        // 兼容短信验证不规范提示信息 || 图片上传
        /*if (res.error) {
          // 提示错误信息
          Message.error(res.error);
        } else if (res.result.msg) {
          // 提示错误信息
          Message.error(res.result.msg ? res.result.msg : `没有获取到数据,或者数据格式是错的!`);
        } else {
          // 提示错误信息
          Message.error(res.result ? res.result : `没有获取到数据,或者数据格式是错的!`);
        }*/
      } else if (res.code == 300) {
        localStorage.clear();
        Message.error('登录过期');
        router.push('/login');
      }
    } else {
      // Spin.hide();
    }
    return data;
  }, error => {
    if (error && error.response) {
      Spin.hide();
      switch ((error.response.status)) { // 跨域存在获取不到状态码的情况
        case 400:
          Message.error('错误请求(400)');
          break;
        case 401:
          Message.error('未授权,请重新登录(401)');
          break;
        case 403:
          Message.error('拒绝访问(403)');
          router.push('/403');
          break;
        case 404:
          Message.error('请求错误,未找到该资源(404)');
          break;
        case 405:
          Message.error('错误请求(405)');
          break;
        case 408:
          Message.error('请求超时(408)');
          break;
        case 500:
          Message.error('服务器错误(500)');
          // router.push('/500');
          break;
        case 501:
          Message.error('服务未实现(501)');
          break;
        case 502:
          Message.error('网络错误(502)');
          break;
        case 503:
          Message.error('服务不可用(503)');
          break;
        case 504:
          Message.error('网络超时(504)');
          break;
        case 505:
          Message.error('HTTP版本不受支持(505)');
          break;
        default:
          Message.error(`'网络出现问题,请稍后再试'`);
          break;
      }
    }
    Spin.hide();
    return Promise.reject(error)
  });
})();

export const getToken = () => {
  return Cookies.get('token')
};



// WEBPACK FOOTER //
// ./src/api/index.js